import React from "react";
import { useAtlas } from "../../store/atlasStore";
import {
  LayoutDashboard, TrendingUp, FlaskConical, Cpu,
  BarChart3, BookOpen, Network, Server, Settings, Hexagon, Activity, Crosshair, Scale
} from "lucide-react";

const NAV_ITEMS = [
  { id: "overview",  icon: LayoutDashboard, tooltip: "Overview" },
  { id: "markets",   icon: TrendingUp,      tooltip: "Markets" },
  { id: "research",  icon: FlaskConical,    tooltip: "Research" },
  { id: "decision",  icon: Cpu,             tooltip: "Decision Engine" },
  { id: "paper",     icon: BarChart3,       tooltip: "Paper Trading" },
  { id: "futures",   icon: Activity,        tooltip: "Derivatives Futures" },
  { id: "options",   icon: Hexagon,         tooltip: "Derivatives Options" },
  { id: "whale",     icon: Crosshair,       tooltip: "Whale Hunter Engine" },
  { id: "statarb",   icon: Scale,           tooltip: "Statistical Arbitrage" },
  null, // separator
  { id: "models",    icon: BookOpen,        tooltip: "Models" },
  { id: "features",  icon: Network,         tooltip: "Features" },
  { id: "system",    icon: Server,          tooltip: "System" },
];

export function Nav() {
  const { state, dispatch } = useAtlas();

  return (
    <nav className="atlas-nav">
      {NAV_ITEMS.map((item, i) => {
        if (item === null) return <div key={`sep-${i}`} className="nav-separator" />;
        const Icon = item.icon;
        const active = state.workspace === item.id;
        return (
          <button
            key={item.id}
            className={`nav-item${active ? " active" : ""}`}
            onClick={() => dispatch({ type: "SET_WORKSPACE", payload: item.id })}
            data-tooltip={item.tooltip}
            aria-label={item.tooltip}
          >
            <Icon />
          </button>
        );
      })}
    </nav>
  );
}
